module.exports = __webpack_public_path__ + "img/sk-logo-transparent.cf1e35d2.png";